import QA from './QA'
export default QA
